import { Injectable } from '@angular/core';
import { CommonService } from '../services/common.service'
import { AuthenticationService } from '../services/authentication.service'
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

    constructor(private http: HttpClient, private common: CommonService, private authentication: AuthenticationService) { }

    getFeedbackType(): any {
        return this.http.get(this.common.apiServiceURL + 'Feedback/getFeedbackType');
    }

    getFeedbackCategory(): any {
        return this.http.get(this.common.apiServiceURL + 'Feedback/getFeedbackCategory');
    }

    getFeedbackById(userId: string, feedbackId: string): any {
        return this.http.get(this.common.apiServiceURL + 'Feedback/getFeedbackById?userId=' + userId + '&feedbackId=' + feedbackId);
    }

    submitFeedbackReply(feedbackId: string, reply: string, userId: string): any {

        //let _authorizationData = this.authentication._authentication;
        //let token = _authorizationData.token;
        let feedbackObj: any = {
            feedback_Id: feedbackId,
            replyPortalUser_Id: userId,
            reply: reply
        }
        return this.http.post(this.common.apiServiceURL + 'Feedback/submitFeedbackReply', feedbackObj);
    }

    getFeedbackReplies(userId: string, feedbackId: string): any {
        return this.http.get(this.common.apiServiceURL + 'Feedback/getFeedbackReplies?userId=' + userId + '&feedbackId=' + feedbackId);
    }

    getUserFeedback(userId: string) {
        return this.http.get(this.common.apiServiceURL + 'Feedback/getUserFeedback?userId=' + userId);
    }

    submitFeedback(feedback: any): any {

        //let _authorizationData = this.authentication._authentication;
        //let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Feedback/submitFeedback', feedback);
    }
}

